export type FormaPagamentoFiscal = {
    id: number
    descricao: string
    selecionada: boolean
}

export type ConfiguracaoFiscalModel = {
    emissaoAutomatica: boolean
    cnpjPlugNotas: string
    tipoEmissao: string
    limiteDiario: string
    emailsFechamentoFiscal: string
    emissoesHoje: number
    formas: FormaPagamentoFiscal[]
}

export const ConfiguracaoFiscalInicial: ConfiguracaoFiscalModel = {
    emissaoAutomatica: false,
    cnpjPlugNotas: "",
    tipoEmissao: "EMISSAO_COM_IMPRESSAO",
    limiteDiario: "",
    emailsFechamentoFiscal: "",
    emissoesHoje: 0,
    formas: [],
}
